const COLS = [
  {
    title: '栏目导航',
    links: [
      { label: '今日速递热榜', href: '#trending' },
      { label: '黑料曝光', href: '#featured' },
      { label: '翻车现场实录', href: '#crash' },
      { label: '塌房合集档案', href: '#archive' },
      { label: '争议事件盘点', href: '#debate' },
      { label: '防迷路 FAQ', href: '#faq' },
    ],
  },
  {
    title: '关于红黑料',
    links: [
      { label: '素材标注原则', href: '#faq' },
      { label: '状态更正机制', href: '#faq' },
      { label: '事实与观点分离', href: '#faq' },
      { label: '合作与投稿说明', href: '#faq' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="border-t border-primary-200 bg-background-100">
      <div className="mx-auto max-w-6xl px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          {/* 品牌 */}
          <div className="md:col-span-5">
            <a href="#top" className="inline-block">
              <h2 className="font-heading text-3xl font-bold leading-none">
                <span className="text-primary-600">红黑</span>
                <span className="text-foreground-950">料</span>
              </h2>
            </a>
            <p className="mt-1 font-heading text-xs tracking-[0.3em] text-foreground-500 uppercase">Honhei · 观察</p>
            <p className="mt-4 max-w-sm text-sm text-foreground-600 leading-relaxed">
              一本轻杂志气质的吃瓜刊：负面事件、黑料曝光、翻车现场与塌房合集，图文并重地整理给你，素材摆明面，结论你自己定。
            </p>
            <div className="mt-5 flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 border border-background-200/80 text-foreground-600 cursor-pointer hover:text-primary-600 transition-colors">
                <i className="ri-weibo-line w-4 h-4 flex items-center justify-center" />
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 border border-background-200/80 text-foreground-600 cursor-pointer hover:text-primary-600 transition-colors">
                <i className="ri-qq-line w-4 h-4 flex items-center justify-center" />
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 border border-background-200/80 text-foreground-600 cursor-pointer hover:text-primary-600 transition-colors">
                <i className="ri-rss-line w-4 h-4 flex items-center justify-center" />
              </span>
            </div>
          </div>

          {COLS.map((c) => (
            <div key={c.title} className="md:col-span-2">
              <h3 className="text-sm font-semibold text-foreground-900">{c.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {c.links.map((l) => (
                  <li key={l.label}>
                    <a href={l.href} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-3">
            <h3 className="text-sm font-semibold text-foreground-900">更新与规则</h3>
            <p className="mt-4 text-xs text-foreground-600 leading-relaxed">
              热榜按事件热度滚动更新，专栏按周归档，存疑素材一律标注待核实。
            </p>
            <span className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-50 px-3 py-1.5 text-xs text-primary-700">
              <i className="ri-time-line w-4 h-4 flex items-center justify-center" />
              每日 09:00 / 18:00 双档更新
            </span>
          </div>
        </div>

        <div className="mt-10 border-t border-background-200/80 pt-6">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 text-xs text-foreground-600">
            <span>© 2026 红黑料 · Honhei. 仅作排版演示。</span>
            <span>本页为静态演示内容，不构成任何事实判断。</span>
          </div>
          <p className="mt-4 rounded-md bg-background-50/80 border border-background-200/60 px-4 py-3 text-[11px] leading-relaxed text-foreground-500">
            免责声明：本页面为排版与栏目演示用途，文中涉及的人物、团体、品牌与事件均为虚构示例，不对应现实中的任何个人、组织或产品。红黑料不传播未经核实的个人信息，存疑素材一律标注“待核实”。
          </p>
        </div>
      </div>
    </footer>
  );
}